import React, { useEffect, useState } from "react";
import { useChatContext } from "stream-chat-react";
import { UserAuth } from "../Context";

const ChatSearch = ({ setFilters }) => {
  const { client } = useChatContext();
  const [searchName, setSearchName] = useState("");
  const { user } = UserAuth();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const searchUsers = async () => {
      if (searchName.trim() === "") {
        setFilters({
          members: { $in: [user?.uid] },
          archived: false,
        });
        return;
      }

      try {
        const response = await client.queryUsers({
          name: { $autocomplete: searchName },
        });
        // const response2 = await client.queryChannels({
        //   name: { $autocomplete: searchName },
        // });
        // console.log("Search response2:", response2);
        // const matchedChannelIds = response2.channels.map((c) => c.id);
        // if (matchedChannelIds.length > 0) {
        //   setFilters({
        //     id: { $in: matchedChannelIds },
        //     archived: false,
        //   });
        // }
        console.log("Search response:", response);
        const matchedUserIds = response.users.map((u) => u.id);

        if (matchedUserIds.length > 0) {
          setFilters({
            members: { $in: matchedUserIds },
            archived: false,
          });
        } else {
          // Show only current user's channels if no match found
          setFilters({
            members: { $in: [user?.uid] },
            archived: false,
          });
        }
      } catch (error) {
        console.error("Search error:", error);
      }
    };

    const delayDebounce = setTimeout(() => {
      searchUsers();
    }, 300); // debounce

    return () => clearTimeout(delayDebounce);
  }, [searchName]);
  return (
    <div
      className="position-relative d-inline-block"
      style={{
        padding: isSmallScreen ? "12px 6px" : "12px 12px 12px 20px",
        width: isSmallScreen ? "100vw" : "23.4vw",
      }}
    >
      <input
        style={{
          width: "100%",
          padding: "6px 8px 6px 28px",
          borderRadius: "8px",
          border: "0.86px solid #C3C3C3",
          fontSize: "14px",
          fontWeight: 400,
          color: "#676A79",
        }}
        type="search"
        name="searchInput"
        placeholder="Search"
        aria-label="Search"
        value={searchName}
        onChange={(e) => setSearchName(e.target.value)}
      />

      <svg
        className="bg-transparent position-absolute p-0 border-0"
        style={{ left: isSmallScreen ? "2%" : "5%", top: "30%", width: "30px" }}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5077 8.40509C11.1961 8.43811 10.9702 8.71754 11.0032 9.02922C11.0363 9.3409 11.3157 9.56679 11.6274 9.53377L11.5077 8.40509ZM12.9086 10.2886C13.0308 10.5772 13.3638 10.7121 13.6525 10.5899C13.9411 10.4678 14.076 10.1347 13.9538 9.84611L12.9086 10.2886ZM15.2698 14.3706C15.048 14.1492 14.6887 14.1495 14.4673 14.3714C14.2458 14.5932 14.2462 14.9525 14.468 15.1739L15.2698 14.3706ZM17.0316 17.733C17.2534 17.9544 17.6127 17.9541 17.8342 17.7323C18.0556 17.5104 18.0553 17.1512 17.8334 16.9297L17.0316 17.733ZM11.6274 9.53377C12.1741 9.47584 12.6943 9.78233 12.9086 10.2886L13.9538 9.84611C13.5447 8.87961 12.5515 8.29449 11.5077 8.40509L11.6274 9.53377ZM14.468 15.1739L17.0316 17.733L17.8334 16.9297L15.2698 14.3706L14.468 15.1739Z"
          fill="#676A79"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.46452 14.6808C6.76291 13.9773 6.28703 13.087 6.09593 12.1202C5.90323 11.1508 6.00218 10.1473 6.38068 9.23223C6.75594 8.32228 7.39661 7.5415 8.22224 6.98795C9.89738 5.86441 12.1026 5.86441 13.7777 6.98795C14.6034 7.5415 15.2441 8.32228 15.6193 9.23223C15.9978 10.1473 16.0968 11.1508 15.904 12.1202C15.713 13.087 15.2371 13.9773 14.5354 14.6808C13.6063 15.6172 12.3314 16.1453 11 16.1453C9.66861 16.1453 8.3937 15.6172 7.46452 14.6808Z"
          stroke="#676A79"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default ChatSearch;
